import {Logger} from 'neo-common';
import { GameDataLoaded, IPlatforms} from './IPlatforms';
import {Platforms} from './Platforms';
import {StatusBar} from '../Plugins';

export class PlatformDummy implements IPlatforms {

    private _message: HTMLDivElement;
    private _messageHeight: number = 0;
    private _iframe: HTMLIFrameElement;

    public create(): void {
        Platforms.canPlay = true;

        if (DEBUG) {
            this.log('create');
        }

        window.addEventListener('message', this.receiveMessage.bind(this));

        this.createMessage();
        this.showMessage('Dummy message');
        this.createIframe();
    }

    public loadProgress(progress: number): void {
        if (DEBUG) {
            this.log('loadProgress');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.progress', 'data': {'progress': progress}
            }, Platforms.pluginOrigin);
        }
    }

    public gameReady(): void {
        if (DEBUG) {
            this.log('gameReady');
        }

        if (Platforms.gameOrigin != null && Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.loaded',
                'data': {
                    'gameOrigin': Platforms.gameOrigin
                }
            }, Platforms.pluginOrigin);
        }
    }

    public gameFailed(): void {
        if (DEBUG) {
            this.log('gameFailed');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.failed'
            }, Platforms.pluginOrigin);
        }
    }

    public gameClosing(): void {
        if (DEBUG) {
            this.log('gameClosing');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.end'
            }, Platforms.pluginOrigin);
        }
    }

    public gameReloading(): void {}

    public gameChange(gameCode: string): void {
        if (DEBUG) {
            this.log('gameChange');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.change', 'data': {'gameCode': gameCode}
            }, Platforms.pluginOrigin);
        }
    }

    public error(code: string, message: string): void {
        if (DEBUG) {
            this.log('error');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.error', 'data': {'code': code, 'message': message}
            }, Platforms.pluginOrigin);
        }
    }

    public clientError(id: string, message: string): void {}

    public roundInit(): void {}

    public roundStarted(): void {
        if (DEBUG) {
            this.log('roundStarted');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.round.started'
            }, Platforms.pluginOrigin);
        }
    }

    public spinStarted(): void {
        if (DEBUG) {
            this.log('spinStarted');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.spin.started'
            }, Platforms.pluginOrigin);
        }
    }

    public spinReceived(): void {}

    public spinEnded(): void {
        if (DEBUG) {
            this.log('spinEnded');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.spin.ended'
            }, Platforms.pluginOrigin);
        }
    }

    public roundEnded(): void {
        if (DEBUG) {
            this.log('roundEnded');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.round.ended'
            }, Platforms.pluginOrigin);
        }
    }

    public featureStarted(): void {
        if (DEBUG) {
            this.log('featureStarted');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.feature.started'
            }, Platforms.pluginOrigin);
        }
    }

    public featureInit(): void {
        if (DEBUG) {
            this.log('featureInit');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.feature.init'
            }, Platforms.pluginOrigin);
        }
    }

    public featureFinished(): void {
        if (DEBUG) {
            this.log('featureFinished');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.feature.finished'
            }, Platforms.pluginOrigin);
        }
    }

    public autoplayStarted(): void {
        if (DEBUG) {
            this.log('autoplayStarted');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.autoplay.started'
            }, Platforms.pluginOrigin);
        }
    }

    public autoplayFinished(): void {
        if (DEBUG) {
            this.log('autoplayFinished');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.autoplay.finished'
            }, Platforms.pluginOrigin);
        }
    }

    public gotoCasier(): void {
        if (DEBUG) {
            this.log('gotoCasier');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.goto.cashier'
            }, Platforms.pluginOrigin);
        }
    }

    public gotoHistory(): void {
        if (DEBUG) {
            this.log('gotoHistory');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.goto.history'
            }, Platforms.pluginOrigin);
        }
    }

    public gotoHelp(): void {}

    public gotoPaytable(): void {}

    public balanceUpdated(): void {}

    public sendPluginMessage(message: string): void {
        if (DEBUG) {
            this.log('sendPluginMessage');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.handleWalletMessage', 'data': {'message': message}
            }, Platforms.pluginOrigin);
        }
    }

    public setVolume(level: number): void {
        if (DEBUG) {
            this.log('setVolume');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.setVolume', 'data': {'level': level}
            }, Platforms.pluginOrigin);
        }
    }

    public quickSpinEnabled(enabled: boolean): void {
        if (DEBUG) {
            this.log('bet');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.quickSpin.enabled', 'data': {'enabled': enabled}
            }, Platforms.pluginOrigin);
        }
    }

    public bet(value: number): void {
        if (DEBUG) {
            this.log('bet');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.bet', 'data': {'bet': value}
            }, Platforms.pluginOrigin);
        }
    }

    public win(value: number): void {
        if (DEBUG) {
            this.log('win');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.win', 'data': {'win': value}
            }, Platforms.pluginOrigin);
        }
    }

    public userAction(action: string, data: Object): void {
        if (DEBUG) {
            this.log('userAction');
        }

        if (Platforms.pluginOrigin != null) {
            window.parent.postMessage({
                'method': 'game.userAction', 'data': {'action': action, 'data': data}
            }, Platforms.pluginOrigin);
        }
    }

    public gameDataLoaded(args: GameDataLoaded): void {}

    public dialogOpened(type: string, isOpen: boolean): void {}

    public fullscreen(enabled: boolean): void {}

    private receiveMessage(event: any): void {
        if (DEBUG) {
            this.log('receiveMessage');
        }

        if (event != null && event.data != null) {
            if (event.data.method != null) {
                switch (event.data.method) {
                    case 'dummy.autoPlay.stop':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.stopAutoplay();
                        }
                        break;
                    case 'dummy.gamePlay.stop':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gamePlayStop();
                        }
                        break;
                    case 'dummy.gamePlay.resume':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gamePlayResume();
                        }
                        break;
                    case 'dummy.gamePlay.freeze':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gamePlayFreeze();
                        }
                        break;
                    case 'dummy.gamePlay.unfreeze':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gamePlayUnfreeze();
                        }
                        break;
                    case 'dummy.audio.enable':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gameAudioEnable();
                        }
                        break;
                    case 'dummy.audio.mute':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.gameAudioMute();
                        }
                        break;
                    case 'dummy.quickSpin.enable':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.quickSpinEnabled(true);
                        }
                        break;
                    case 'dummy.quickSpin.disable':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.quickSpinEnabled(false);
                        }
                        break;
                    case 'showPlugin':
                        if (this.checkOrigin(event.origin)) {
                            this.showPlugin();
                        }
                        break;
                    case 'hidePlugin':
                        if (this.checkOrigin(event.origin)) {
                            this.hidePlugin();
                        }
                        break;
                    case 'showHelp':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.showHelp();
                        }
                        break;
                    case 'hideHelp':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.hideHelp();
                        }
                        break;
                    case 'toggleHelp':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.toggleHelp();
                        }
                        break;
                    case 'hidePaytable':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.hidePaytable();
                        }
                        break;
                    case 'showPaytable':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.showPaytable();
                        }
                        break;
                    case 'togglePaytable':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.togglePaytable();
                        }
                        break;
                    case 'dummy.balance.reload':
                        if (this.checkOrigin(event.origin)) {
                            Platforms.refreshBalance();
                        }
                        break;
                }
            }
        }
    }

    private checkOrigin(origin: string): boolean {
        if (Platforms.pluginOrigin !== '*' && origin !== Platforms.pluginOrigin) {
            return false;
        }

        return true;
    }

    private createMessage(): void {
        if (DEBUG) {
            this.log('createMessage');
        }
    }

    private showMessage(message: string): void {
        if (DEBUG) {
            this.log('showMessage');
        }

        const statusBar = StatusBar.getInstance();
        statusBar.add(StatusBar.Types.Message, 'dummyPlatformMsg', message);
    }

    private createIframe(): void {
        if (DEBUG) {
            this.log('createIframe');
        }

        this._iframe = <HTMLIFrameElement>(document.createElement('iframe'));
        this._iframe.id = 'topIframe';
        this._iframe.src = 'http://static.dev.int';
        this._iframe.classList.add('_disabled');

        document.body.appendChild(this._iframe);
    }

    private showPlugin(): void {
        if (DEBUG) {
            this.log('showPlugin');
        }

        if (this._iframe != null) {
            if (this._iframe.classList.contains('_disabled')) {
                this._iframe.classList.remove('_disabled');
            }
        }
    }

    private hidePlugin(): void {
        if (DEBUG) {
            this.log('hidePlugin');
        }

        if (this._iframe != null) {
            if (!this._iframe.classList.contains('_disabled')) {
                this._iframe.classList.add('_disabled');
            }
        }
    }

    protected log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup('Dummy', 'Dummy' + s);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Platforms/PlatformDummy.ts
 **/